import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';

export interface ListItem {
    arrow?: boolean;
    count?: number;
    href?: string;
    icon?: string;
    title: string;
    tracking?: string;
    attributes?: StringDictionary<string | number>;
    bgColor?: string;
    colouredIcon?: string;
    sitecoreId?: string;
    userSegmentGroups?: string;
}

export interface TreeItem extends ListItem {
    id: string | number;
    expanded: boolean;
    active: boolean;
    children: TreeItem[];
    compoundId?: string;
    regions?: number[];
}

export class TreeSeparatorItem implements TreeItem {
    constructor(public title: string) {}

    get expanded(): boolean {
        return false;
    }

    get active(): boolean {
        return false;
    }

    get children(): TreeItem[] {
        return [];
    }

    get arrow(): boolean | undefined {
        return;
    }

    get count(): number | undefined {
        return;
    }

    get icon(): string | undefined {
        return;
    }

    get tracking(): string | undefined {
        return;
    }

    get href(): string {
        return '';
    }

    get id(): string {
        return 'separator';
    }
}
